import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative w-full h-[400px] md:h-[500px] overflow-hidden" aria-label="阅读号召">
      <img
        src="https://readdy.ai/api/search-image?query=Dreamy%20manga%20reading%20atmosphere%20with%20floating%20comic%20pages%20and%20ink%20brush%20strokes%2C%20warm%20evening%20light%2C%20cozy%20reading%20nook%20vibe%2C%20Chinese%20watercolor%20and%20ink%20art%20style%2C%20golden%20and%20amber%20tones%2C%20artistic%20and%20inspiring%20composition%20with%20depth%20and%20texture&width=1600&height=800&seq=cta-bg-01&orientation=landscape"
        alt="在线阅读漫画"
        className="w-full h-full object-cover object-top"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/70 via-foreground-950/40 to-foreground-950/70"></div>

      <div className="absolute inset-0 flex items-center justify-center">
        <div className="text-center px-6">
          <h2 className="text-2xl md:text-5xl font-display font-bold text-white mb-4">
            随时随地，畅享阅读
          </h2>
          <p className="text-sm md:text-lg text-white/70 max-w-xl mx-auto mb-8">
            无需注册，无需下载，打开浏览器即可阅读。下拉式漫画浏览，流畅快速，追漫从未如此简单。
          </p>
          <Link
            to="/category/all"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 font-medium text-sm transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            开始阅读
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}